export const MILLISECONDS_IN_MONTH = 1000 * 60 * 60 * 24 * 30;
export const STATIC_PATH = '/gp-onboarding';

export const BASE_PATHS = {
  household: '/kalkulator-ubezpieczenia-nieruchomosci',
  apartExtendedWarranty:
    '/ubezpieczenia-dodatkowe/rozszerzona-ochrona-compensa-partner',
  compensaBicycleExtendedWarranty:
    '/ubezpieczenia-dodatkowe/ubezpieczenie-roweru/kalkulator',
  compensaKrossExtendedWarranty:
    '/ubezpieczenia-dodatkowe/rozszerzona-ochrona-compensa-kross/kalkulator',
  compensaKrossWebExtendedWarranty:
    '/ubezpieczenia-dodatkowe/ubezpieczenie-roweru-kross/kalkulator',
  compensaSwissExtendedWarranty:
    '/ubezpieczenia-dodatkowe/rozszerzona-ochrona-compensa-swiss/kalkulator',
  compensaConsumerelectronicsExtendedWarranty:
    '/ubezpieczenia-dodatkowe/rozszerzona-ochrona-compensa-consumerelectronics/kalkulator',
  beesafeSchoolPA: '/ubezpieczenia-dodatkowe/ubezpieczenie-szkolne/kalkulator',
  compensaNNW: '/ubezpieczenia-dodatkowe/nnw-compensa-provident/kalkulator',
  compensaHomeAssistance:
    '/ubezpieczenia-dodatkowe/home-assistance-compensa/kalkulator',
  compensaOzeExtendedWarranty:
    '/ubezpieczenia-dodatkowe/ubezpieczenie-oze/kalkulator',
  compensaHyperbookExtendedWarranty:
    '/ubezpieczenia-dodatkowe/rozszerzona-ochrona-compensa-hyperbook/kalkulator',
  compensaHyperbookWebExtendedWarranty:
    '/ubezpieczenia-dodatkowe/ubezpieczenie-laptopa-hyperbook/kalkulator',
  compensaDronePilotTPL: '/ubezpieczenia-dodatkowe/oc-operatora-drona/kalkulator',
  compensaOldDronePilotTPL: '/ubezpieczenia-dodatkowe/oc-pilota-drona/kalkulator',
  compensaEngineerTPL:
    '/ubezpieczenia-dodatkowe/nadwyzkowe-oc-inzyniera/kalkulator',
  compensaEngineerTPLSoleProprietorship:
    '/ubezpieczenia-dodatkowe/oc-inzyniera-jdg/kalkulator',
  compensaEngineerAccidentInsurance:
    '/ubezpieczenia-dodatkowe/nnw-inzyniera/kalkulator',
  compensaSchoolAccidentGroupInsurance:
    '/nnw-szkolne-grupowe',
  compensaSchoolAccidentIndividualInsurance:
    '/ubezpieczenie/nnw-szkolne-indywidualne/kalkulator',
  charterYacht:
    '/ubezpieczenia-dodatkowe/czarter-casco/kalkulator',
  compensaKLC:
    '/cudzoziemcy/kalkulator',
  developerPortal: '/frontend-gp-onboarding',
} as const;
